import React, { useState } from "react";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import { Link, graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import circleImg1 from "../../../assets/images/product-detail/circle2.png";
import circleImg2 from "../../../assets/images/product-detail/circle1.png";

import Informacion_de_Polizas from "../../../assets/images/ipad/Informacion_de_Polizas.png"
import Informacion_de_Pagos from "../../../assets/images/ipad/Informacion_de_Pagos.png"
import Historial_de_Siniestros from "../../../assets/images/ipad/Historial_de_Siniestros.png"
import Endosos from "../../../assets/images/ipad/Endosos.png"
import Hoy_no_Circula from "../../../assets/images/ipad/Hoy_no_Circula.png"
import Multas from '../../../assets/images/ipad/Multas.png'
import Avisos from '../../../assets/images/ipad/Avisos.png'

const query = graphql`
	{
		allFile(filter: { relativeDirectory: { eq: "ipad" }, ext: { ne: "png" } }) {
			nodes {
				name
				childImageSharp {
					gatsbyImageData(placeholder: BLURRED, height: 550)
				}
			}
		}
	}
`;
const SectionWrapper = styled.section`
	padding: 100px 0;
	position: relative;

	.circle-img1 {
		position: absolute;
		width: 250px;
		top: 10px;
		left: 30%;
		z-index: -1;
	}

	.circle-img2 {
		position: absolute;
		width: 250px;
		bottom: 20px;
		right: 30%;
		z-index: -1;
	}

	h1 {
		color: #5268c2;
		font-weight: 700;
		margin-bottom: 50px;
	}
	.tab-pane {
		min-height: 550px;
		@media only screen and (max-width: 700px) {
			min-height: 400px;
		}
	}
`;

const imgNotification = (id) => {
	if(id === 'Informacion_de_Polizas') {
		return <img src={Informacion_de_Polizas} alt={`${Informacion_de_Polizas}`} />
	}
	else if(id === 'Informacion_de_Polizas') {
		return <img src={Informacion_de_Polizas} alt={`${Informacion_de_Polizas}`} />
	}

	else if(id === 'Informacion_de_Pagos') {
		return <img src={Informacion_de_Pagos} alt={`${Informacion_de_Pagos}`} />
	}
	else if(id === 'Historial_de_Siniestros') {
		return <img src={Historial_de_Siniestros} alt={`${Historial_de_Siniestros}`} />
	}
	else if(id === 'Endosos') {
		return <img src={Endosos} alt={`${Endosos}`} />
	}
	else if(id === 'Hoy_no_Circula') {
		return <img src={Hoy_no_Circula} alt={`${Hoy_no_Circula}`} />
	}
	else if(id === 'Multas') {
		return <img src={Multas} alt={`${Multas}`} />
	}
	else if(id === 'Avisos') {
		return <img src={Avisos} alt={`${Avisos}`} />
	}
}

const Technologia = [
	{
		id: "Informacion_de_Polizas",
		desc: "Información de Pólizas",
	},
	{
		id: "Informacion_de_Pagos",
		desc: "Información de Pagos",
	},
	{
		id: "Historial_de_Siniestros",
		desc: "Historial de Siniestros",
	},
	{
		id: "Endosos",
		desc: "Endosos",
	},
	{
		id: "Hoy_no_Circula",
		desc: "Hoy no Circula",
	},
	{
		id: "Multas",
		desc: "Multas",
	},
	{
		id: "Avisos",
		desc: "Avisos",
	},
];

const Technology = ({ title }) => {
	const [selected, setSelected] = useState("Informacion_de_Polizas");
	const data = useStaticQuery(query);
	const nodes = data.allFile.nodes;

	const GetImageByKey = (name) => {
		let _img = null;
		Object.entries(nodes).filter((img) => {
			if (img[1].name === name) {
				// _img = getImage(img[1]);
				_img = require(`../../../assets/images/ipad/${name}.png`)
			}
		});
		return _img;
	};
	return (
		<SectionWrapper className='technology-section'>
			<img src={circleImg1} alt='circle1' className='circle-img1' />
			<div className='container'>
				{title && <h1 className='h1 text-center text-primary'>{title}</h1>}
				<h1 className='text-center'>
					Tecnología = <span className='text-primary'>Simplicidad</span>
				</h1>
				<p
					className='text-center'
					style={{
						color: "#5268c2",
						fontSize: 17,
						fontWeight: 600,
					}}>
					Hay eventos que cuando ocurren, te causan una pérdida económica
					importante. <br />
					Por esta razón, contar con un seguro para tu auto te ayudará a manejar
					tranquilo. <br />
					En caso de accidente, las consecuencias pueden ir desde un alto costo
					de reparación de tu vehículo, un gran daño material a otros vehículos
					e incluso personas lesionadas. Con un seguro de auto, se podrá
					compensar la pérdida o daño y tu situación económica no se verá
					afectada. <br />
				</p>
				<div className='row'>
					<div className='col-md-4 col-lg-3'>
						<div className='nav flex-column nav-pills'>
							{Technologia.map((tech, key) => (
								<span
									key={tech.id + key}
									style={{ cursor: "pointer" }}
									onClick={() => setSelected(tech.id)}
									className={
										selected == tech.id ? "nav-link active" : "nav-link "
									}>
									{tech.desc}
								</span>
							))}
						</div>
					</div>
					<div className='col-md-8 col-lg-9'>
						<div className='tab-content'>
							{Technologia.map((tech, key) => (
								<Link
									key={tech + key + 2}
									style={{ minHeight: 550 }}
									className={`tab-pane fade ${
										tech.id == selected ? "show active" : ""
									}`}
									id={tech.id}
									role='tabpanel'
									aria-labelledby={tech.id + "-tab"}>
									{/* <GatsbyImage
										fadeIn={false}
										image={GetImageByKey(tech.id)}
										alt='technology'
									/> */}
									
									{
										imgNotification(tech.id)
									}
									
								</Link>
							))}
						</div>
					</div>
				</div>
			</div>
			<img src={circleImg2} alt='circle2' className='circle-img2' />
		</SectionWrapper>
	);
};

export default Technology;
